// extracted by mini-css-extract-plugin
export default {"oosNotify":"A5-z","count":"B5-z","otherColors":"C5-z","modalContent":"D5-z","body":"E5-z"};